module.exports = __webpack_public_path__ + "img/icons B_28.56c26ea7.png";